import React from 'react'
import { useNavigate } from 'react-router-dom'

import { ChangeTwoFactorDevice } from './ChangeTwoFactorDevice'
import { ChangeTwoFactorDeviceContainerProps } from './ChangeTwoFactorDevice.types'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useMutation } from '@percent/partner-dashboard/common/hooks'

export function ChangeTwoFactorDeviceContainer({ isOpened, onClose }: ChangeTwoFactorDeviceContainerProps) {
  const navigate = useNavigate()
  const { authService } = useServices()

  const [{ isLoading, errorMessage }, { apiFunc: generateQRToken }] = useMutation(authService.generateQRCode, data => {
    if (data?.data?.data?.otpKey) {
      navigate('/2fa-setup', { state: { otpData: data?.data?.data } })
    }
  })

  return (
    <ChangeTwoFactorDevice
      generateQRToken={generateQRToken}
      errorMessage={errorMessage}
      isOpened={isOpened}
      isLoading={isLoading}
      onClose={onClose}
    />
  )
}
